export const API_BASE = process.env.API_ENDPOINT;

export const API_ROUTES = {
  GET_PAGES_ROUTE: "/pages",
  GET_NAV_ROUTE: "/menu",
  GET_OPTIONS_GROUP: "/options/{name}",
  GET_ACF_ON_PAGE: "/page-acf/{slug}",
};

export const strings = {
  BACK_TO_TOP: "Idi na početak",
};

export const menuSlug = "menu-1";
